module.exports = __webpack_public_path__ + "static/img/九号电动T自平衡探索版.fa17ee41.png";